/* Personnalisation (bloc « nky_perso » de main-product, 21/10/2026) : modèle, photos, texte → propriétés de la ligne.
   Les photos partent avec le formulaire de Dawn (FormData = envoi multipart) : un <input type=file> caché par photo,
   rattaché au formulaire par l'attribut form, nommé « Photo » ou « Photo 1 », « Photo 2 »… selon le modèle.
   Collage : chaque photo est réduite à 2400 px (elle sera petite sur le puzzle, et la requête reste légère). */
(function () {
  if (window.nkyPerso) return;
  window.nkyPerso = true;
  var moinsDeMouvement = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var PLAFOND_COLLAGE = 2400, PLAFOND_OCTETS = 18 * 1024 * 1024, PLAFOND_SEULE = 6000;

  function reduire(fichier, cote) {
    return new Promise(function (ok) {
      var url = URL.createObjectURL(fichier), img = new Image();
      img.onload = function () {
        var w = img.naturalWidth, h = img.naturalHeight, k = Math.min(1, cote / Math.max(w, h));
        if (k === 1 && fichier.size <= PLAFOND_OCTETS) { URL.revokeObjectURL(url); ok(fichier); return; }
        var c = document.createElement('canvas');
        c.width = Math.round(w * k); c.height = Math.round(h * k);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        c.toBlob(function (blob) {
          URL.revokeObjectURL(url);
          if (!blob) { ok(fichier); return; }
          ok(new File([blob], fichier.name.replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' }));
        }, 'image/jpeg', 0.92);
      };
      img.onerror = function () { URL.revokeObjectURL(url); ok(fichier); };   /* HEIC hors Safari : envoyé tel quel */
      img.src = url;
    });
  }

  function init(carte) {
    if (carte.dataset.nkyPret) return;
    carte.dataset.nkyPret = '1';
    var formId = carte.dataset.form;
    var radios = [].slice.call(carte.querySelectorAll('.nky-perso__radio'));
    var choisir = carte.querySelector('[data-nky-perso-choisir]');
    var zone = carte.querySelector('[data-nky-perso-zone]');
    var grille = carte.querySelector('[data-nky-perso-grille]');
    var envoi = carte.querySelector('[data-nky-perso-envoi]');
    var compteur = carte.querySelector('[data-nky-perso-compteur]');
    var petite = carte.querySelector('[data-nky-perso-petite]');
    var erreur = carte.querySelector('[data-nky-perso-erreur]');
    var titreUn = carte.querySelector('[data-nky-perso-un]');
    var titrePlusieurs = carte.querySelector('[data-nky-perso-plusieurs]');
    var texte = carte.querySelector('[data-nky-perso-texte]');
    var reste = carte.querySelector('[data-nky-perso-reste]');
    var minPx = parseInt(carte.dataset.minPx, 10) || 0;
    var nomPhoto = carte.dataset.nomPhoto || 'Photo';
    var photos = [];          /* { fichier, url, petite } dans l'ordre d'ajout */
    var enCours = 0;          /* photos en cours de réduction */

    function besoin() {
      var r = radios.filter(function (x) { return x.checked; })[0];
      return r ? Math.max(1, parseInt(r.dataset.photos, 10) || 1) : 1;
    }

    function rendre() {
      var n = besoin();
      photos.splice(n).forEach(function (p) { URL.revokeObjectURL(p.url); });   /* modèle avec moins de photos : on garde les premières */
      grille.textContent = '';
      photos.forEach(function (p, i) {
        var case_ = document.createElement('div');
        case_.className = 'nky-perso__photo' + (p.petite ? ' is-petite' : '');
        var img = document.createElement('img');
        img.src = p.url; img.alt = ''; img.decoding = 'async';
        img.onerror = function () { img.remove(); case_.classList.add('is-sans-apercu'); };
        var x = document.createElement('button');
        x.type = 'button'; x.className = 'nky-perso__retirer';
        x.setAttribute('aria-label', (carte.dataset.retirer || '') + ' ' + (i + 1));
        x.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
        x.addEventListener('click', function () {
          URL.revokeObjectURL(p.url);
          photos.splice(photos.indexOf(p), 1);
          rendre();
          choisir.focus({ preventScroll: true });
        });
        case_.appendChild(img); case_.appendChild(x);
        grille.appendChild(case_);
      });

      var plein = photos.length >= n;
      zone.hidden = plein;
      choisir.multiple = n - photos.length > 1;
      if (titreUn) titreUn.hidden = n > 1;
      if (titrePlusieurs) titrePlusieurs.hidden = n <= 1;
      compteur.textContent = n > 1 ? photos.length + ' / ' + n : '';
      carte.classList.toggle('is-collage', n > 1);
      petite.hidden = !photos.some(function (p) { return p.petite; });
      if (plein) { erreur.hidden = true; carte.classList.remove('is-manque'); }

      /* champs envoyés avec le formulaire : un par photo */
      envoi.textContent = '';
      photos.forEach(function (p, i) {
        var champ = document.createElement('input');
        champ.type = 'file';
        champ.name = 'properties[' + nomPhoto + (n > 1 ? ' ' + (i + 1) : '') + ']';
        champ.setAttribute('form', formId);
        try {
          var dt = new DataTransfer();
          dt.items.add(p.fichier);
          champ.files = dt.files;
        } catch (e) { return; }
        envoi.appendChild(champ);
      });
    }

    function verifierTaille(p) {
      if (!minPx) return;
      var img = new Image();
      img.onload = function () {
        p.petite = Math.max(img.naturalWidth, img.naturalHeight) < minPx;
        if (p.petite) rendre();
      };
      img.src = p.url;
    }

    function ajouter(fichiers) {
      var n = besoin();
      var liste = [].slice.call(fichiers || []).filter(function (f) {
        return /^image\//.test(f.type) || /\.(heic|heif)$/i.test(f.name);
      }).slice(0, Math.max(0, n - photos.length));
      liste.forEach(function (f) {
        enCours++;
        reduire(f, n > 1 ? PLAFOND_COLLAGE : PLAFOND_SEULE).then(function (pret) {
          enCours--;
          if (photos.length >= besoin()) return;
          var p = { fichier: pret, url: URL.createObjectURL(f), petite: false };
          photos.push(p);
          verifierTaille(p);
          rendre();
        });
      });
    }

    function signalerManque() {
      erreur.hidden = false;
      carte.classList.remove('is-manque'); void carte.offsetWidth; carte.classList.add('is-manque');
      carte.scrollIntoView({ behavior: moinsDeMouvement ? 'auto' : 'smooth', block: 'center' });
    }

    choisir.addEventListener('change', function () { ajouter(choisir.files); choisir.value = ''; });
    ['dragenter', 'dragover'].forEach(function (t) {
      zone.addEventListener(t, function (e) { e.preventDefault(); zone.classList.add('is-survol'); });
    });
    ['dragleave', 'drop'].forEach(function (t) {
      zone.addEventListener(t, function () { zone.classList.remove('is-survol'); });
    });
    zone.addEventListener('drop', function (e) { e.preventDefault(); ajouter(e.dataTransfer && e.dataTransfer.files); });
    radios.forEach(function (r) { r.addEventListener('change', rendre); });

    if (texte && reste) {
      var majReste = function () { reste.textContent = texte.value.length + '/' + texte.maxLength; };
      texte.addEventListener('input', majReste); majReste();
    }

    /* capture sur document : on passe avant le gestionnaire d'ajout de Dawn, qui écoute le formulaire lui-même.
       Le formulaire de Dawn a un champ nommé « id » (la variante) : form.id renvoie ce champ, d'où getAttribute. */
    document.addEventListener('submit', function (e) {
      if (!e.target || !e.target.getAttribute || e.target.getAttribute('id') !== formId) return;
      if (photos.length >= besoin() && !enCours) return;
      e.preventDefault(); e.stopImmediatePropagation();
      signalerManque();
    }, true);

    function choisirModele(i, defiler) {
      var r = radios[i - 1];
      if (!r) return;
      r.checked = true;
      rendre();
      if (defiler) carte.scrollIntoView({ behavior: moinsDeMouvement ? 'auto' : 'smooth', block: 'start' });
    }
    /* « #modele-2 » choisit le 2e modèle et ramène à la carte ; « #personnaliser » ramène à la carte sans rien changer */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#modele-"], a[href$="#personnaliser"]');
      if (!a) return;
      e.preventDefault();
      var m = (a.getAttribute('href') || '').match(/#modele-(\d+)/);
      if (m) { choisirModele(parseInt(m[1], 10), true); return; }
      carte.scrollIntoView({ behavior: moinsDeMouvement ? 'auto' : 'smooth', block: 'start' });
    });
    var h = location.hash.match(/^#modele-(\d+)/);
    if (h) setTimeout(function () { choisirModele(parseInt(h[1], 10), true); }, 300);

    /* éditeur : choisir un bloc « modèle » le sélectionne dans la carte */
    document.addEventListener('shopify:block:select', function (e) {
      var l = carte.querySelector('[data-bloc="' + (e.detail && e.detail.blockId) + '"] .nky-perso__radio');
      if (l) { l.checked = true; rendre(); }
    });

    rendre();
  }

  function tout() { document.querySelectorAll('[data-nky-perso]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
  document.addEventListener('shopify:section:load', tout);
})();
